import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Alumno, Circular, NotaAgenda, Autorizacion, Calendar} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAgendaService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** PRIVADO  ***/
  /*** agenda ***/

  // getCalendario(curso: string): Promise<Calendar[]> {
  //   const url = `${this.apiUrl}agenda/educadoras/${curso}`;
  //   return firstValueFrom(this.http.get<Calendar[]>(url))
  // }
  getCalendarioCentro(curso: string): Promise<Calendar> {
    const url = `${this.apiUrl}agenda/centro/${curso}`;
    return firstValueFrom(this.http.get<Calendar>(url))
  }
  getAgendaMes(mes: number, year: number): Promise<[Alumno[],Alumno[],Circular[],Autorizacion[],NotaAgenda[]]> {
    const url = `${this.apiUrl}agenda/${mes}/${year}`;
    return firstValueFrom(this.http.get<[Alumno[],Alumno[],Circular[],Autorizacion[],NotaAgenda[]]>(url))
  }
  getFestivosCurso = (curso: string): Promise<{fecha: string, festivo: number}[]> => {
    const url = `${this.apiUrl}agenda/${curso}`;
    return firstValueFrom(this.http.get<{fecha: string, festivo: number}[]>(url))
  }
  saveAgenda(data: NotaAgenda): Promise<void> {
    const url = `${this.apiUrl}agenda`;
    return firstValueFrom(this.http.post<void>(url, data))
  }
  deleteAgenda(date: string): Promise<void> {
    const url = `${this.apiUrl}agenda/${date}`;
    return firstValueFrom(this.http.delete<void>(url))
  }
  deleteNotaAgenda(date: string): Promise<void> {
    const url = `${this.apiUrl}agenda/nota/${date}`;
    return firstValueFrom(this.http.delete<void>(url))
  }

}
